import { Position } from '@xyflow/react'
import React from 'react'
import { useModuleFormContext } from 'src/contexts/ModuleForm'
import { IMessage } from 'src/models/module'
import {
  ModuleContainer,
  ModuleContent,
  ModuleHeaderContainer
} from 'src/shared/styled/Module'
import LanguageMapForm from 'src/shared/views/LanguageMapForm'
import FirstTaskButton from './FirstTaskButton'
import NodeHandle from './NodeHandle'

interface IMessageNode {
  data: IMessage
}

const MessageNode = React.memo(({ data }: IMessageNode) => {
  /**
   * ----- Hook Initialization -----
   */

  const { moduleFormData, updateTask } = useModuleFormContext()

  /**
   * ----- Render -----
   */

  return (
    <>
      <NodeHandle type="target" position={Position.Top} />
      <ModuleContainer>
        <ModuleHeaderContainer>
          <h3>Message</h3>
          <FirstTaskButton taskId={data.taskId} />
        </ModuleHeaderContainer>
        <ModuleContent>
          <LanguageMapForm
            value={data.text}
            onChange={(value) => {
              updateTask({ ...data, text: value })
            }}
            supportedLanguages={moduleFormData.supportedLanguages}
            textFieldProps={{
              multiline: true,
              minRows: 2
            }}
          />
        </ModuleContent>
      </ModuleContainer>
      <NodeHandle type="source" position={Position.Bottom} />
    </>
  )
})

export const MessageNodeForm = ({ data }: IMessageNode) => {
  /**
   * ----- Hook Initialization -----
   */

  const { moduleFormData, updateTask } = useModuleFormContext()

  /**
   * ----- Render -----
   */

  return (
    <div>
      <h3>Message</h3>
      <LanguageMapForm
        value={data.text}
        onChange={(value) => {
          updateTask({ ...data, text: value })
        }}
        supportedLanguages={moduleFormData.supportedLanguages}
        textFieldProps={{
          multiline: true
        }}
      />
    </div>
  )
}

export default MessageNode
